import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.scss";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import Cards from "../components/Cards";
import Bar from "../components/Bar";
import MultipleBarCharts from "../components/MultipleBarCharts";
import MultipleLineCharts from "../components/MultipleLineCharts";
import "../components/Report.scss";
import FeatureIcon from "mdi-react/CheckCircleOutlineIcon";
import Icon from "../components/Icon.jsx";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
  _getFeaturesArr,
  _chunkArray,
  _isCoop,
  _validUnitSources,
  propertyExportFL,
  propertyFL,
  _formatNum,
  _getBuildingPhotos,
  _getServiceLevel,
  _checkBuildingAltAdr,
  _calPercentage,
  _checkFieldForValue,
} from "../../../../../../shared/helpers/utils";
import { amenitiesList } from "../../../../../../shared/helpers/bp-utils.js";
import { userEditFieldsObj } from "../../../../../../shared/helpers/userEditFields.js";
import {
  generatePeriodNames,
  prepareResForAI,
  filterAIData,
  getCurrentPeriod,
  getPriorPeriod,
  getRangeEnd,
  getRangeStart,
  formatDate,
  validateNestedData,
  formatDateRange,
  percentageChange,
} from "../../../exportreport/utils";
import CustomTable from "../../components/CustomTable";
import CustomBarChart from "../components/CustomBarChart";
import { height } from "@material-ui/system";
import Amenities from "../components/Amenities";
import { building } from "../../../../../DataExport/components/EmptyExportList/components/EmptyList";
import { formValues } from "redux-form";
import Footer from "./../../reports/components/Footer";
import CircularProgress from "../components/CircularProgress.jsx";
import SubHeader from "../components/SubHeader.jsx";
import CustomLineChart from "../components/CustomLineChart.jsx";
import { classNames } from 'classnames';
import CustomSkeleton from "../components/Skeleton.jsx";

const apiURL = process.env.API_ROOT;

let statTypes = [
  {
    key: "residential_sales",
    title: "Condo, Co-op and Single-Family Homes",
    name: "Market Overview",
    checkedColor: "#D5E1A3",
    activitesQuery: "event_tags:(condo* co?op* coop* condo*p single?family)",
    default: true,
  },

  {
    key: "condo",
    title: "New and Resale Condos",
    name: "Condo",
    checkedColor: "#780F9E",
    activitesQuery:
      '(event_tags:(condo* !condo*p) AND -address_2_normalized:"")',
    default: true,
  },
  {
    key: "coop",
    title: "New and Resale Co-ops",
    name: "Co-op",
    checkedColor: "#28C2FF",
    activitesQuery:
      '(event_tags:(co?op* coop* condo*p) AND -address_2_normalized:"")',
    default: true,
  },
  {
    key: "single_family",
    title: "Townhouses and Detached Single-Family Homes",
    name: "Single-Family",
    checkedColor: "#FFD23F",
    activitesQuery: "(event_tags:(single?family))",
  },
];

function roundUpToNearest(number, roundFactor = 25000) {
  if (number > 99000000) {
    // Round up to the nearest million (i.e. remove any thousands digits)
    return Math.ceil(number / 1000000) * 1000000;
  }
  // Otherwise, round up to the nearest roundFactor (default is 25,000)
  const rounded = Math.ceil(number / roundFactor) * roundFactor;
  return rounded > number ? rounded : number;
}
function formatPropertyData(input, isSubject) {
  
    return {
        id: input.id || "comp1",
        isSubject: isSubject,
        img: "https://newsapidev.marketproof.com/buildings/pictures/" + input.building,
        title: input.display_full_street_address + (input.address_2_normalized ?  " - " + input.address_2_normalized.toUpperCase() : ""),
        location: 
            (input.neighborhood && input.neighborhood.length > 0 
                ? input.neighborhood[0].charAt(0).toUpperCase() + input.neighborhood[0].slice(1) 
                : "") + 
            (input.borough ? ", " + input.borough.charAt(0).toUpperCase() + input.borough.slice(1) : ""),
        type: _isHouse(input) && input.ownership_type =="rental" ? "House/Townhouse" : input.ownership_type 
            ? input.ownership_type.charAt(0).toUpperCase() + input.ownership_type.slice(1) 
            : "Unknown",
        yearBuilt: input.year_built > 0 ? input.year_built : "N/A",
        bedsBaths: input.bedrooms > -1 ? input.bedrooms + " Bed / " + input.baths + " Bath" : "--",
        size: input.sq_ft ? input.sq_ft.toLocaleString() + " SF" : "N/A",
        price: isSubject ? _formatPrice(input['suggestedPrice']) : input.last_listed_sale_price_all > 0 
            ? _formatPrice(input.last_listed_sale_price_all)
            : "N/A",
        priceType: isSubject ? "Suggested Price" : "Asking Price",
        psf: isSubject ? "$" +_formatNumber(input['suggestedPricePPSF']) : input["div(last_listed_sale_price_all, sq_ft)"] > 0 
            ? "$" + _formatNumber(input["div(last_listed_sale_price_all, sq_ft)"])
            : "N/A",
        psfType: isSubject ? "Suggested List PSF" : "Asking PSF",
        daysOnMarket: isSubject ? null : input.last_listed_sale_date_all > 0 
        ? Math.round((Date.now() / 1000 - input.last_listed_sale_date_all) / (60 * 60 * 24))
        : "N/A",
        daysOnMarketHeading: isSubject ? "Expected DOM " : "Days on Market",
        // Add the date attribute formatted as MM/DD/YYYY:
        date: !isSubject && input.last_listed_sale_date_all > 0
            ? input.last_listed_sale_modified_date_all > input.last_listed_sale_date_all ? 
            new Date(input.last_listed_sale_modified_date_all * 1000).toLocaleDateString("en-US", {
                month: "numeric",
                day: "numeric",
                year: "numeric"
            }):
            new Date(input.last_listed_sale_date_all * 1000).toLocaleDateString("en-US", {
                  month: "numeric",
                  day: "numeric",
                  year: "numeric"
              })
            : false,
        tag: isSubject ? "SUBJECT" :  "COMP",
        buildingAmenities: input.building_features ? input.building_features : [],
        unitFeature: input.property_features ? input.property_features : [],
        floor: input.floor ? input.floor : null
    };
}

function formatPropertyDataSold(input, isSubject) {
    return {
        id: input.id || "comp1",
        isSubject: isSubject,
        img: "https://newsapidev.marketproof.com/buildings/pictures/" + input.building,
        title: input.display_full_street_address + (input.address_2_normalized ?  " - " + input.address_2_normalized.toUpperCase() : ""),
        location: 
            (input.neighborhood && input.neighborhood.length > 0 
                ? input.neighborhood[0].charAt(0).toUpperCase() + input.neighborhood[0].slice(1) 
                : "") + 
            (input.borough ? ", " + input.borough.charAt(0).toUpperCase() + input.borough.slice(1) : ""),
        type: _isHouse(input) && input.ownership_type =="rental" ? "House/Townhouse" : input.ownership_type 
            ? input.ownership_type.charAt(0).toUpperCase() + input.ownership_type.slice(1) 
            : "Unknown",
        yearBuilt: input.year_built > 0 ? input.year_built : "N/A",
        bedsBaths: input.bedrooms > -1 ? input.bedrooms + " Bed / " + input.baths + " Bath" : "--",
        size: input.sq_ft ? input.sq_ft.toLocaleString() + " SF" : "N/A",
        price: isSubject ? _formatPrice(input['suggestedPrice']) : input.last_sold_price > 0 
            ? _formatPrice(input.last_sold_price)
            : "N/A",
        priceType: isSubject ? "Suggested List Price" : "Sold Price",
        psf: isSubject ? "$" +_formatNumber(input['suggestedPricePPSF']) : input["div(last_sold_price, sq_ft)"] > 0 
            ? "$" + _formatNumber(input["div(last_sold_price, sq_ft)"])
            : "N/A",
        psfType: isSubject ? "Suggested PSF" : "Sold PSF",
       
        // Add the date attribute formatted as MM/DD/YYYY:
        date: !isSubject && input.last_sold_date > 0
            ? new Date(input.last_sold_date * 1000).toLocaleDateString("en-US", {
                  month: "numeric",
                  day: "numeric",
                  year: "numeric"
              })
            : false,
        tag: isSubject ? "SUBJECT" :  "COMP",
        buildingAmenities: input.building_features ? input.building_features : [],
        unitFeature: input.property_features ? input.property_features : [],
        floor: input.floor ? input.floor : null
    };
}

function calculateAverages(data, priceField, sqFtField) {
    if (!Array.isArray(data) || data.length === 0) {
        return { avgPrice: 0, avgPPSF: 0 };
    }

    let totalPrice = 0;
    let totalSqFt = 0;
    let validCount = 0;

    data.forEach(item => {
        const price = parseFloat(item[priceField]);
        const sqFt = parseFloat(item[sqFtField]);

        if (!isNaN(price) && !isNaN(sqFt) && sqFt > 0) {
            totalPrice += price;
            totalSqFt += sqFt;
            validCount++;
        }
    });

    return {
        avgPrice: validCount > 0 ? totalPrice / validCount : 0,
        avgPPSF: totalSqFt > 0 ? totalPrice / totalSqFt : 0
    };
}

let MIN_COUNT = 10;
const BlendedLayout = (props) => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    theme,
    compSettings,
    setAiResponse,
    AiResponse,
    setFetchAi,
    fetchAi,
    setAIInProgress
  } = props;

  const { dateOptions } = customDate;
  const currentPeriod = getCurrentPeriod(dateOptions);
  const priorPeriod = getPriorPeriod(dateOptions);

  const priorYearPeriod = priorPeriod;
  const rangeEnd = getRangeEnd(dateOptions);
  const rangeStart = getRangeStart;
  const gap = dateOptions.gap;
  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;
  
  
  // useEffect(() => {
  //   console.log(reportData, fetchInProgress, submit, "mySubmit");
  //   if (!reportData && !fetchInProgress && submit) {
  //     loadData();
  //     setSubmit(false);
  //   }
  // }, [submit]);
  
  const getDerived = (theReportData) => {
    
    if (theReportData) {
     
    
      let subjectProperty = theReportData.compSettings.propertyDetails.property;
      subjectProperty = Object.assign(subjectProperty, theReportData.compSettings.propertyDetails);
      subjectProperty["suggestedPrice"] =
        theReportData &&
        theReportData.compResponse &&
        theReportData.compResponse.suggestedPrice
          ? theReportData.compResponse.suggestedPrice
          : 0;
      subjectProperty["suggestedPricePPSF"] =
        subjectProperty["suggestedPrice"] / subjectProperty["sq_ft"];
      subjectProperty["suggestedPriceLow"] = subjectProperty["suggestedPrice"] * 0.9;
      subjectProperty["suggestedPriceHigh"] = subjectProperty["suggestedPrice"] * 1.1;
      let avgDOM = theReportData.compResponse.avgDOM ? theReportData.compResponse.avgDOM : null;
      let avgDiscount = theReportData.compResponse.avgDiscount
        ? (Number.parseFloat(theReportData.compResponse.avgDiscount).toFixed(1)) * -1
        : null;
      let activeComps = theReportData.compResponse.comps.active.slice(0, 3);
      let avgActiveComps = calculateAverages(activeComps, "last_listed_sale_price_all", "sq_ft");
      let soldComps = theReportData.compResponse.comps.sold.slice(0, 3);
      let avgSoldComps = calculateAverages(soldComps, "last_sold_price", "sq_ft");
      let currentCashBuyers = theReportData.compResponse.currentCashBuyers;
      let currentFinancedBuyers = theReportData.compResponse.currentFinancedBuyers;
      let percentCashBuyers =
        currentCashBuyers.count && currentFinancedBuyers.count
          ? Number.parseFloat(
              (currentCashBuyers.count /
                (currentCashBuyers.count + currentFinancedBuyers.count)) *
                100
            ).toFixed(0)
          : "--";
      let percentFinanced = currentFinancedBuyers.avg_financed
        ? Number.parseFloat(100 - currentFinancedBuyers.avg_financed).toFixed(0)
        : "--";
      let activityResponse = theReportData.compResponse.activityResponse
        ? theReportData.compResponse.activityResponse
        : null;
        
      const {buildingRes} = theReportData;
      
      const isCoop =["coop"].indexOf(buildingRes.ownership_type)>=0;
    
      return {
        subjectProperty,
        avgDOM,
        avgDiscount,
        activeComps,
        avgActiveComps,
        soldComps,
        avgSoldComps,
        currentCashBuyers,
        currentFinancedBuyers,
        percentCashBuyers,
        percentFinanced,
        activityResponse,
        isCoop
      };
    }
  }

  useEffect(() => {
    console.log(reportData, fetchInProgress, submit, "mySubmit");
  
    if (!reportData && !fetchInProgress && submit) {
      const fetchData = async () => {
        await loadData(); 
  
  
      };
  
     fetchData();
  
      setSubmit(false);
   
    }
  }, [submit]);
  
  useEffect(() => {
    console.log(reportData, fetchAi)
      const fetchAIData = async () => {
       setFetchAi &&  setFetchAi(false);
       setAIInProgress(true);
       
       const aiResponse = await handleAIGenerate(reportData);
   
        setAiResponse &&  setAiResponse(aiResponse);
        setAIInProgress(false);
      };
    
      if ( reportData && fetchAi) {
        fetchAIData();
        
      }
    }, [reportData, fetchAi])
  
//  
// 
  // setFetchInProgress(false);
  // setReportLoaded(true);
  // setSubmit(false);

  const getLastMonthsQuery = (fieldName, months) => {
      const now = Math.floor(Date.now() / 1000); // Current timestamp in seconds
      const monthsAgo = now - (months * 30 * 24 * 60 * 60); // Approximate number of months (30 days per month)

      return `${fieldName}:[${monthsAgo} TO ${now}]`;
  }
  const loadData = async () => {

    const addressQ = compSettings.selectedBuilding.alternate_addresses.join('" OR "');
    let q = `alternate_addresses:("${addressQ}") AND (zip:${compSettings.selectedBuilding.zip} OR borough:"${compSettings.selectedBuilding.borough.toLowerCase()}")`;

    const fq = [
      "deleted:false",
    ];
    setFetchInProgress(true);
    let axiosData = {
      url: apiURL + "/query/we3-buildings?cache=60",
      method: "post",
      query: {
        q: q,
        wt: "json",
        fl: "key,display_full_street_address,name,geocode,borough,neighborhood,markets_major,zip,floors,inventory_total,year_built,year_converted,building_service_level,building_access,amenities_health,ownership_type,total_units,building_style",
        fq: fq,
        rows: 1,
      },
    };

    let res = await _axiosCall(axiosData)
      .then(async (res) => {
        let aiData;

        if (res && res.docs && res.docs[0]) {
          // aiData = prepareResForAI(JSON.parse(JSON.stringify(res.facets)));
          // //
          // res["aiResponse"] = aiResponse;
          let building = res.docs[0];
          if(building.ownership_type && building.ownership_type.toLowerCase() == "co-op"){
            building.ownership_type = "coop";
          }
          const compResponse = await getComps(building);
          let theReportData = {
            buildingRes: building,
            compResponse,
            compSettings
          };
          const derivedData = getDerived(theReportData);
          theReportData['derivedData'] = derivedData;
          console.log(theReportData);
          
          setReportData(theReportData);
         
        }
        return res;
      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        setFetchInProgress(false);
        setReportLoaded(true);
        setSubmit(false);
        setFetchAi && setFetchAi(true);
      });
  };
  
  const handleAIGenerate = async (theReportData) => {
    const { buildingRes, derivedData, compResponse, compSettings } = theReportData;

    const {
      subjectProperty,
      avgDOM,
      avgDiscount,
      activeComps,
      avgActiveComps,
      soldComps,
      avgSoldComps,
      currentCashBuyers,
      currentFinancedBuyers,
      percentCashBuyers,
      percentFinanced,
      activityResponse,
      isCoop
    } = derivedData;
    const {
      domTrends,
      discountTrends,
      ppsfTrends
    } = compResponse;
    
    let userSuggestedPrice = compSettings.propertyDetails && compSettings.propertyDetails.customPrice && parseInt(compSettings.propertyDetails.customPrice)>100 ? parseInt(compSettings.propertyDetails.customPrice) : false;
     
    let subjectBaselineData = [];
     
    subjectBaselineData.push(`suggested subject price: ${subjectProperty['suggestedPrice']}`);
    if(compResponse['latestPrice'] && compResponse['latestPrice']['value']>0 && compResponse['latestPrice']['date']){
      subjectBaselineData.push(`subject last known price: ${compResponse['latestPrice']['value']}`);
      subjectBaselineData.push(`subject last known price date: ${compResponse['latestPrice']['date']}`);
      subjectBaselineData.push(`subject last known price type: ${compResponse['latestPrice']['type']}`);
      if(compResponse['priceChange'] && compResponse['priceChange']['relativeAppreciation']){
        subjectBaselineData.push(`appreciation of similar property since subject's last known price: ${compResponse['priceChange']['relativeAppreciation']}`);
      }
    }
   
    
    let subjectCompData = [];
     
    if(avgActiveComps && avgActiveComps['avgPPSF']){
      subjectCompData.push(`on the market comps avg ppsf: ${avgActiveComps['avgPPSF']}`);
      subjectCompData.push(`on the market comps avg price: ${avgActiveComps['avgPrice']}`);
    }
    if(avgSoldComps && avgSoldComps['avgPPSF']){
      subjectCompData.push(`recently sold comps avg ppsf: ${avgSoldComps['avgPPSF']}`);
      subjectCompData.push(`recently sold comps avg price: ${avgSoldComps['avgPrice']}`);
    }
    
    let domData = [];
    if(avgDOM){
      domData.push(`average days on market last 6 months: ${Math.round(avgDOM)}`);
    }
    if(domTrends && domTrends.length>1){
 
      domData.push(`average days on market this ytd: ${Math.round(domTrends[domTrends.length-1].avg_dom)}`);
      domData.push(`average days on market last year: ${Math.round(domTrends[domTrends.length-2].avg_dom)}`);
    }
   
    let discountData = [];
    if(avgDiscount){
      discountData.push(`average discount last 6 months: ${avgDiscount}%`);
    }
    if(discountTrends && discountTrends.length>0){
      discountData.push(`average discount this ytd: ${discountTrends[discountTrends.length-1].avg_discount * -1}%`);
      discountData.push(`average discount last year: ${discountTrends[discountTrends.length-2].avg_discount * -1}%`);
    } 
    
    let cashFinanceData = [];
    if(percentCashBuyers){
      cashFinanceData.push(`% cash buyers: ${percentCashBuyers}%`);
    }
    if(percentFinanced && !isCoop){
      cashFinanceData.push(`% down payment: ${percentFinanced}%`);
    }
    
    let strategyData = [];
    if(subjectProperty['suggestedPriceLow']){
      strategyData.push(`Low range: ${roundUpToNearest(subjectProperty['suggestedPriceLow'])}`);
      strategyData.push(`High range: ${roundUpToNearest(subjectProperty['suggestedPriceHigh'])}`);
    }
    
    
     let prompt;
     
     if(userSuggestedPrice){
       prompt = `Write a price_overview (Store in JSON Response: price_overview) around 100 words that tells the reader how the subject property's suggested price was derived using expert input based on the property's condition, size, amenities and market trends in ${_capitalizeText(buildingRes.neighborhood)}, then finding similar properties as comps.  If last known is a listed price, don't be so absolute about that's value of the property but just using it as a singal.  Use the following data elements as appropriate. \n${subjectBaselineData.join("\n")}\n\n`;
       
       prompt += `Write a comp_overview (Store in JSON Response: comp_overview) around 80 words that tells the reader how the subject property's suggested price was refined by using similar properties  in ${_capitalizeText(buildingRes.neighborhood)} currently on the market and recently sold.  Tell them we look at relative valuation of each comp to derive a price. Use the following data elements as appropriate. \n${subjectCompData.join("\n")}\n\n`;
       
     }else if(compResponse && compResponse['latestPrice'] && compResponse['latestPrice']['value']>0){
        prompt = `Write a price_overview (Store in JSON Response: price_overview) around 100 words that tells the reader how the subject property's suggested price was derived using its historical price (sale or last listed on the market based on subject last known price type) and total market appreciation (or decpreciation) of similar properties since the subject property's last known price date in ${_capitalizeText(buildingRes.neighborhood)}, then finding similar properties as comps.  If last known is a listed price, don't be so absolute about that's value of the property but just using it as a singal.  Use the following data elements as appropriate. \n${subjectBaselineData.join("\n")}\n\n`;
        
        prompt += `Write a comp_overview (Store in JSON Response: comp_overview) around 80 words that tells the reader how the subject property's suggested price was refined by using similar properties  in ${_capitalizeText(buildingRes.neighborhood)} currently on the market and recently sold.  Tell them we look at relative valuation of each comp to derive a price. Use the following data elements as appropriate. \n${subjectCompData.join("\n")}\n\n`;
     }else{
       prompt = `Write a price_overview (Store in JSON Response: price_overview) around 100 words that tells the reader how the subject property's suggested price was derived using pricing of similar properties in ${_capitalizeText(buildingRes.neighborhood)}.  By using a combination of comparable properties on the market and those recently sold. \n${subjectBaselineData.join("\n")}\n\n`;
       
       prompt += `Write a comp_overview (Store in JSON Response: comp_overview) around 80 words that tells the the subject property's price is refined by comparing qualities of each property. Use the following data elements as appropriate. \n${subjectCompData.join("\n")}\n\n`;
     }
     
     
    
     
     prompt += `Write a days_on_market (Store in JSON Response: days_on_market) around 40 words for a days on market analysis for similar properties in ${_capitalizeText(buildingRes.neighborhood)}, focus on last 6 months but also give brief analysis of this year vs. last year. Use the following data elements as appropriate. \n${domData.join("\n")}\n\n`;
     
     prompt += `Write a discount (Store in JSON Response: discount) around 40 words for a discount analysis (sold vs listed price) for similar nearby properties, focus on last 6 months but also give brief analysis of this year vs. last year. Use the following data elements as appropriate. \n${discountData.join("\n")}\n\n`;
     
     
     if(isCoop){
       prompt += `Write an analysis for % cash buyers of similar properties to the subject property (Store in JSON Response: cash_finance) around 80 words. Use the following data elements as appropriate. \n${cashFinanceData.join("\n")}\n\n`;
     }else{
       prompt += `Write an analysis for % cash buyers and avg % down payment of similar properties to the subject property (Store in JSON Response: cash_finance) around 80 words. Use the following data elements as appropriate. \n${cashFinanceData.join("\n")}\n\n`;
     }
    
     //prompt += " Don’t justify your answers. Don’t give information not mentioned in the Marketproof Data.";
     
     prompt += `Write an summary for subject property pricing strategy options (Store in JSON Response: pricing_strategy) around 100 words.  Corrleate range of suggested price to current discount and days on market.  Use the following data elements as appropriate. \n${strategyData.join("\n")}\n${domData.join("\n")}\n${discountData.join("\n")}\n\n`;
     
     
     
     let theOnTheMarketComps = [...[formatPropertyData(subjectProperty, true)], ...activeComps.map(item => formatPropertyData(item))].map((property, index) => {
       return JSON.stringify(property)
     })
     if(theOnTheMarketComps.length>1){
       prompt += `Write a narrative for on the market comps (Store in JSON Response: active_comps) around 100 words.  Compare the comps to the subject property denoted, justify for why a comp is more or less expensive than the the suggested price for subject property of ${subjectProperty['suggestedPrice']} focus on size, location, floor, amenities, quality of unit and age.   Use the following data elements as appropriate. \n${theOnTheMarketComps.join("\n")}\n\n`;
     }else{
       prompt += `Write a narrative for on the market comps (Store in JSON Response: active_comps) around 100 words.  Noting that no comparables are curently on the market given the uniquness of the subject property.  Explain that further evvaluation of the subject and pricing is required to establish an accurate price.  Use the following data elements as appropriate. \n${theOnTheMarketComps.join("\n")}\n\n`;
     }
    
     
     let theSoldComps = [...[formatPropertyDataSold(subjectProperty, true)], ...soldComps.map(item => formatPropertyDataSold(item))].map((property, index) => {
        return JSON.stringify(property)
      })
    if(theSoldComps.length>1){
       prompt += `Write an summary for recently sold comps (Store in JSON Response: sold_comps) around 100 words.  Compare the comps to the subject property denoted, justify for why a comp is more or less expensive than the the suggested price for subject property of ${subjectProperty['suggestedPrice']} focus on size, location, floor, amenities, quality of unit and age.    Use the following data elements as appropriate. \n${theSoldComps.join("\n")}\n\n`;
     }else{
       prompt += `Write a narrative for on the market comps (Store in JSON Response: active_comps) around 100 words.  Noting that no comparables are have sold recently given the uniquness of the subject property.  Explain that further evvaluation of the subject and pricing is required to establish an accurate price.  Use the following data elements as appropriate. \n${theSoldComps.join("\n")}\n\n`;
     }
     
     
     let supplyDemandData = activityResponse.map(item => {
      return JSON.stringify({ year: item.val.slice(0,4), new_listings: item.new_listings && item.new_listings.count ? Math.round(item.new_listings.count) : 0, contracts_signed: item.contract_signed && item.contract_signed.count ? Math.round(item.contract_signed.count) : 0})
     })
     
     prompt += `Write an summary to explain the supply and demand trend (Store in JSON Response: supply_demand_1 and supply_demand_2) around 150 words.  Supply is new ${_capitalizeText(buildingRes.ownership_type)}  listings of similar properties in  ${_capitalizeText(buildingRes.neighborhood)} and demand are contracts signed.  Split into two paragraph (supply_demand_1 and supply_demand_2), first should explain what is supply and demand and second analyze the trends in the data.  correlate likely external factors that may drive supply and demend, e.g. covid, mortgage rates, financial factors during the period.  Use the following data elements as appropriate. \n${supplyDemandData.join("\n")}\n\n`;
     
     let thePriceTrendData = ppsfTrends.map(item => {
     return  JSON.stringify({ year: item.val.slice(0,4), ppsf: Math.round(item.med_ppsf)})})
     prompt += `Write an summary to explain the price trend (Store in JSON Response: price_trend) around 120 words.  Price trend  refers to PPSF of similar properties in  ${_capitalizeText(buildingRes.neighborhood)}.  Correlate likely external factors that may drive supply and demend, e.g. covid, mortgage rates, financial factors during the period.  Use the following data elements as appropriate. \n${thePriceTrendData.join("\n")}\n\n`;
     
     let theDOMTrendData = domTrends.map(item => {
     return JSON.stringify({ date: item.val.slice(0,4), dom: Math.round(item.avg_dom) })})
      prompt += `Write an summary to explain the days on market trend (Store in JSON Response: dom_trend) around 60 words.  DOM trend  refers to days on market of similar properties in  ${_capitalizeText(buildingRes.neighborhood)}. Use the following data elements as appropriate. \n${theDOMTrendData.join("\n")}\n${domData.join("\n")}\n\n`;
      
    
    let theDiscountTrendData = discountTrends.map(item => {
     return JSON.stringify({ date: item.val.slice(0,4), discount: item.avg_discount * -1 })})
      prompt += `Write an summary to explain the discount trend (Store in JSON Response: discount_trend) around 60 words.  Discount trend  refers to sold price vs listed price of similar properties in  ${_capitalizeText(buildingRes.neighborhood)}.  If there's a negative discount, it means propertie traded at or above asking price, say that. Use the following data elements as appropriate. \n${theDiscountTrendData.join("\n")}\n${discountData.join("\n")}\n\n`;
         
     
     let systemContent = `You are a real estate agent helping a seller make sense of the value of the subject property, the results will be used as narrative for a comp report.  Abbreviate long currency so it's $1.5M, round if less than $1M.  If less than $1M use K.  No deimcals for prices.  Number should be in format ###,###,###. tone in a professional but friendly tone, use simple terms.  `;
   
     
     prompt += ` The results should be in valid raw JSON format, no formatting.  { "price_overview" :  "text", comp_overview: "text", "days_on_market": "text", "discount": "text", "cash_finance" : "text",  "pricing_strategy": "text", "active_comps" : "text", "sold_comps" : "text", , "supply_demand_1" : "text", "supply_demand_2" : "text", "price_trend" : "text", "dom_trend" : "text", "discount_trend" : "text" } }`
       
    const queryData = {
      messages: [
        {
          role: "system",
          content: systemContent,
        },
        { role: "user", content: prompt },
      ],
      model: "gpt-4o-mini",
      response_format: { type: "json_object" },
    };
  
    const axiosData = {
      url: apiURL + "/ai/chat",
      method: "post",
      query: queryData,
    };
    let aiResponse = {};
    try {
      const res = await _axiosCall(axiosData);
      console.log(res);
    
      if (
        res &&
        res.choices &&
        res.choices[0] &&
        res.choices[0].message &&
        res.choices[0].message.content
      ) {
        const result = res.choices[0].message.content;
    
        try {
          aiResponse = JSON.parse(result);
          console.log(aiResponse);
        } catch (e) {}
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return aiResponse;
   
  };
  

  const getComps = async (building) => {

    const fq = [
      "deleted:false",
    ];
    
    let isHouse = _isHouse(building);

    let propertyDetails = compSettings.propertyDetails;
    let property = compSettings.propertyDetails.property ? compSettings.propertyDetails.property : null;
    let userSuggestedPrice = compSettings.propertyDetails && compSettings.propertyDetails.customPrice && parseInt(compSettings.propertyDetails.customPrice)>100 ? parseInt(compSettings.propertyDetails.customPrice) : false;
    

    
    property = Object.assign(property, propertyDetails);
    let bedroomQuery = propertyDetails.bedrooms !== "" && parseInt(propertyDetails.bedrooms) > -1 && !isHouse
        ? `bedrooms:${propertyDetails.bedrooms == 0 ? '(0 1)' : propertyDetails.bedrooms}`
        : '';
    if(userSuggestedPrice && bedroomQuery){
      bedroomQuery= ` OR ${bedroomQuery}^5.0`;
    }

    const bathsQuery = propertyDetails.baths > 0
        ? `baths:${propertyDetails.baths}^3.0`
        : '';

    const sqFtQuery = _shouldShow(propertyDetails.sq_ft)
    ? ` OR sq_ft:[${Math.round(propertyDetails.sq_ft*.8)} TO ${Math.round(propertyDetails.sq_ft*1.2)}]^3.0`
    : '';

    const buildingKeyQuery = _shouldShow(building.key)
    ? ` OR building:${building.key}^5.0`
    : '';

    const neighborhoodQuery = _shouldShow(building.neighborhood)
    ? building.neighborhood.length > 1
      ? ' OR neighborhood:("' + building.neighborhood.join('" "') + '")^1.7'
      : ' OR neighborhood:"' + building.neighborhood + '"^1.7'
    : false;

    const boroughQuery = _shouldShow(building.borough)
    ? 'borough:"' + building.borough + '"'
    : false;

    const floorQuery = property && _shouldShow(property.floor) && property.floor > 0
    ? ` OR floor:[${parseInt(property.floor * .7) + ' TO ' + parseInt(property.floor * 1.3)}]^2.5`
    : false;

    const buildingYearQuery = _shouldShow(building.year_built)
    ? ` OR year_built:[${(building.year_built - 10) + ' TO ' + (building.year_built + 15)}]^1`
    : '';

    const unitField = 'inventory_total';
    const totalUnitsPerc = _shouldShow(building[unitField])
        ? building[unitField] >= 20
          ? _calPercentage(building[unitField],
              (building[unitField] >= 300 ? 70 : building[unitField] >= 100 ? 30 : building[unitField] >= 40 ? 15 : 5)
            )
          : 10
        : undefined;
    const lowEnd = Math.round(building[unitField] - totalUnitsPerc);
    const highEnd = Math.round(building[unitField] + totalUnitsPerc);
    const buildingUnitQuery = `${totalUnitsPerc  ? ' OR total_units:[' + (lowEnd < 0 ? 0 : lowEnd) + ' TO ' + (highEnd) + ']^4.5' : ''}`;

    const amenitiesToQueryForArr = [
      { val: 'doorman',
        field: 'building_service_level',
        query: '*doorman*'
      },
      { val: 'elevator',
        field: 'building_access',
        query: '*elevator'
      },
      { val: ["gym", "fitness-room", "fitness room", "fitness_room", "fitness-center", "fitness_center", "fitness center", "health club", "health-club", "health_club"],
        field: 'amenities_health',
        query: '(gym fitness?room fitness?center health?club fitness?facilit*)'
      }
    ];

    const amenitiesQueryValues = amenitiesToQueryForArr.reduce((acc, current) => {
        if(_checkFieldForValue(building, current.field, current.val)) {
          acc.push(`${Array.isArray(current.val) ? current.val[0] : current.val}`);
        }

        return acc;
      }
    , []);
    console.log("amenitiesQueryValues", amenitiesQueryValues, amenitiesQueryValues.length > 0)

    const amenitiesQuery = [];
    if(amenitiesQueryValues.length > 0) {
      for(let i = 0; i < amenitiesQueryValues.length; i++) {
        const amenitiesVal = amenitiesQueryValues[i];
        const amenitiesObj = amenitiesToQueryForArr.find(el => el.val.indexOf(amenitiesVal) > -1);

        // amenitiesQuery.push('(building_features:' + amenitiesObj.query + ' OR ' + amenitiesObj.field + ':' + amenitiesObj.query + ')')
        amenitiesQuery.push('(building_features:' + amenitiesObj.query + ')^1')
      }
    }
    // console.log("amenitiesQuery", amenitiesQuery)

    const amentitiesStr = amenitiesQuery.join(' OR ');

    const amenitiesQ = `${amentitiesStr ? ' OR ' + amentitiesStr : ''}`;

    const removeSubject = _shouldShow(property.key) ? `-key:${property.key}` : null;

    let ownershipTypeQuery = _shouldShow(building.ownership_type) ? `ownership_type:${building.ownership_type.split('-')[0]}` : null;
    if(isHouse){
      ownershipTypeQuery = `ownership_type:*family*`;
    }

   

    const getLatestPrice = (data) => {
      // Destructure relevant fields from the input object
      let {
        last_listed_sale_price_all,
        last_listed_sale_date_all,
        last_sold_price,
        last_sold_date,
        property_status,
        offering_submitted_date,
        offering_reviewed_date,
        offering_accepted_date,
        offering_effective_date,
        last_listed_sale_modified_date_all
      } = Object.assign({},data);
      
      if(last_listed_sale_modified_date_all > last_listed_sale_date_all){
        last_listed_sale_date_all = last_listed_sale_modified_date_all;
      }

      // Convert Unix timestamp `last_listed_sale_date_all` to ISO format if valid
      let effectiveLastListedDate =
        last_listed_sale_date_all && last_listed_sale_date_all > 0
          ? new Date(last_listed_sale_date_all * 1000).toISOString()
          : null;

      // If last_listed_sale_date_all is invalid and property_status is 'sponsor', evaluate offering dates
      if (
        (!last_listed_sale_date_all || last_listed_sale_date_all <= 0) &&
        property_status === "sponsor"
      ) {
        // Collect all offering dates and filter out null/invalid values
        const offeringDates = [
          offering_submitted_date,
          offering_reviewed_date,
          offering_accepted_date,
          offering_effective_date
        ].filter(date => date && !isNaN(new Date(date).getTime()));

        // Pick the most recent date
        if (offeringDates.length > 0) {
          effectiveLastListedDate = offeringDates.reduce((latest, current) => {
            return new Date(current) > new Date(latest) ? current : latest;
          });
        }
      }

      // Convert Unix timestamp `last_sold_date` to ISO format if valid
      const formattedLastSoldDate =
        last_sold_date && last_sold_date > 0
          ? new Date(last_sold_date * 1000).toISOString()
          : null;

      // Create an array of price types with their corresponding dates
      const priceTypes = [
        { type: "listed_sale_price", value: last_listed_sale_price_all, date: effectiveLastListedDate },
        { type: "sold_price", value: last_sold_price, date: formattedLastSoldDate }
      ];

      // Filter out entries with invalid values (null, -1) or invalid dates
      const validPriceTypes = priceTypes.filter(
        item => item.value !== null && item.value !== -1 && item.date && !isNaN(new Date(item.date).getTime())
      );

      // Find the latest price type based on the date
      const latestPriceType = validPriceTypes.reduce(
        (latest, current) => (new Date(current.date) > new Date(latest.date) ? current : latest),
        { date: new Date(0).toISOString() } // Initial comparison with the earliest possible date
      );

      // Return the latest price type with date in ISO format, or null if no valid price is found
      return latestPriceType.date > new Date(0).toISOString()
        ? { ...latestPriceType }
        : null;
    };

    const calculateRelativeAppreciation = (initialDate, priceTrends) => {
      // Convert the initialDate to a timestamp
      if(!priceTrends || !priceTrends.filter(trend => trend.med_ppsf > 0)) return null;
      const initialTimestamp = new Date(initialDate).getTime();

      // Find the trend closest to the initialDate
      const initialTrend = priceTrends.reduce((closest, current) => {
        const currentTimestamp = new Date(current.val).getTime();
        const closestTimestamp = new Date(closest.val).getTime();

        // Skip invalid data points
        if (!current.med_ppsf || current.count === 0) return closest;

        // Compare the absolute difference in timestamps
        return Math.abs(currentTimestamp - initialTimestamp) <
               Math.abs(closestTimestamp - initialTimestamp)
          ? current
          : closest;
      });

      // Check if a valid initial trend was found
      if (!initialTrend || !initialTrend.med_ppsf) {
        return { error: 'No valid initial trend data found for the given date' };
      }

      // Find the latest trend with a nonzero avg_ppsf
      const latestTrend = [...priceTrends].reverse().find(trend => trend.count >= MIN_COUNT);
      
      // Check if a valid latest trend was found
      if (!latestTrend) {
        return { error: 'No valid trend data with a nonzero avg_ppsf found' };
      }

      // Calculate relative appreciation
      const initialPPSF = initialTrend.med_ppsf;
      const latestPPSF = latestTrend.med_ppsf;
      const relativeAppreciation = ((latestPPSF - initialPPSF) / initialPPSF);

      // Return the results
      return {
        initialDate: initialTrend.val,
        initialPPSF,
        latestDate: latestTrend.val,
        latestPPSF,
        relativeAppreciation: relativeAppreciation // Format as a percentage
      };
    }
    
    function calculateRelativeValue(priceTrend, subjectProperty, compProperty) {
      // Helper function to find the closest PPSF in the price trend
      
      if(!priceTrends || !priceTrends.filter(trend => trend.med_ppsf > 0)) return null;
      const getPPSFByDate = (date) => {
        if (!date || isNaN(date)) {
          throw new Error(`Invalid date: ${date}`);
        }
        const targetDate = new Date(date * 1000); // Convert Unix timestamp to Date
        return priceTrend.filter(trend => trend.med_ppsf > 0).reduce((closest, current) => {
          const currentDate = new Date(current.val);
          const closestDate = new Date(closest.val);
    
          // Ensure med_ppsf exists and is a valid number
          if (isNaN(current.med_ppsf)) {
            throw new Error(`Invalid med_ppsf in price trend: ${JSON.stringify(current)}`);
          }
    
          // Find the closest date in the price trend
          return Math.abs(currentDate - targetDate) < Math.abs(closestDate - targetDate)
            ? current
            : closest;
        });
      };
    
      // Helper function to get the latest nonzero med_ppsf
      const getLatestNonZeroPPSF = () => {
        const latestTrend = [...priceTrend].reverse().find(trend => trend.med_ppsf > 0 && trend.count >= MIN_COUNT);
        return latestTrend.med_ppsf
        throw new Error("No valid nonzero med_ppsf found in price trend");
      };
    
      try {
        // Get PPSF for subject property and comp property based on their last sold dates
        const subjectPPSFTrend = getPPSFByDate(subjectProperty.last_sold_date);
        const compPPSFTrend = getPPSFByDate(compProperty.last_sold_date);
    
        // Get the latest nonzero PPSF for normalization
        const mostRecentPPSF = getLatestNonZeroPPSF();
    
        // Normalize the values of the properties using med_ppsf
        const subjectNormalizedValue =
          subjectProperty.last_sold_price * (mostRecentPPSF / subjectPPSFTrend.med_ppsf);
        const compNormalizedValue =
          compProperty.last_sold_price * (mostRecentPPSF / compPPSFTrend.med_ppsf);
    
        // Calculate the relative percentage
        const relativePercentage = ((compNormalizedValue / subjectNormalizedValue) - 1) * 100;
    
        return {
          subjectNormalizedValue: subjectNormalizedValue.toFixed(2),
          compNormalizedValue: compNormalizedValue.toFixed(2),
          relativePercentage: relativePercentage.toFixed(2) + '%'
        };
      } catch (error) {
        return { error: error.message };
      }
    }
    const getAverageCount = (priceTrends) => {
        if (!priceTrends.length) return 0; // Avoid division by zero
        const total = priceTrends.reduce((sum, item) => sum + (item.count || 0), 0);
        return total / priceTrends.length;
    };
    
    let latestPrice = property ? getLatestPrice(property) : false;
    if(!latestPrice){
      latestPrice = {date:"2015-01-01T05:00:00Z", value:0}
    }
    let priceTrends, domTrends, currentDOM, discountTrends, currentDiscount, ppsfTrends, currentCashBuyers, currentFinancedBuyers, priceChange;
    let expectedCurrentPrice = latestPrice ? latestPrice.value : false;
    
    let activityResponse = await getActivities(building);
    console.log(activityResponse, latestPrice)
   // if(latestPrice){
     let trendResponse = await getPriceTrends(building, latestPrice);
     priceTrends =  trendResponse.price_trend ? trendResponse.price_trend : null;
     MIN_COUNT = getAverageCount(priceTrends) * .33; // MAKE SURE THERE'S BIG ENOUGH SAMPLE
     domTrends = trendResponse.dom_trend ? trendResponse.dom_trend.filter(item => item.count >= MIN_COUNT) : null;
     currentDOM = trendResponse.current_dom ? trendResponse.current_dom : null;
     discountTrends = trendResponse.discount_trend ? trendResponse.discount_trend.filter(item => item.count >= MIN_COUNT) : null;
     ppsfTrends = trendResponse.ppsf_trend ? trendResponse.ppsf_trend.filter(item => item.count >= MIN_COUNT) : null;
     currentDiscount = trendResponse.current_discount ? trendResponse.current_discount : null;
     currentCashBuyers = trendResponse.current_cash_buyers ? trendResponse.current_cash_buyers : null;
     currentFinancedBuyers = trendResponse.current_financed_buyers ? trendResponse.current_financed_buyers : null;
    console.log(latestPrice, priceTrends);
    if(priceTrends){
      priceChange = calculateRelativeAppreciation(latestPrice.date, priceTrends);
      console.log("priceChange", latestPrice, priceChange);
      if(priceChange && priceChange.relativeAppreciation){
        expectedCurrentPrice = ((1 + (priceChange.relativeAppreciation)) * latestPrice.value);
      }

    }
    //}

    console.log("expectedCurrentPrice", expectedCurrentPrice);
    // Define baseline and maximum thresholds.
    const priceThreshold = 10000000;    // $10M baseline
    const maxPrice = 100000000;         // $200M upper limit
    
    // Baseline multipliers and date ranges (for properties at or below $10M)
    const baseLow = 0.6, baseHigh = 1.5;
    const baseActive = 6, baseSold = 24;
    
    // Maximum multipliers and date ranges (for properties at or above $200M)
    const maxLow = 0.3, maxHigh = 3.0;
    const maxActive = 48, maxSold = 120;
    
    // Start with baseline values.
    let multiplierLow = baseLow;
    let multiplierHigh = baseHigh;
    let activeMonthRange = baseActive;
    let soldMonthRange = baseSold;
    
    // If expectedCurrentPrice is above $10M, adjust values using square-root interpolation.
    if (expectedCurrentPrice && expectedCurrentPrice > priceThreshold) {
      // Compute a base ratio from 0 (at $10M) to 1 (at $200M)
      const baseFactor = (expectedCurrentPrice - priceThreshold) / (maxPrice - priceThreshold);
      // Use square-root scaling for a larger factor in the mid-range.
      const factor = Math.min(Math.sqrt(baseFactor), 1);
      
      // Interpolate multipliers:
      multiplierLow  = baseLow  - factor * (baseLow  - maxLow);
      multiplierHigh = baseHigh + factor * (maxHigh - baseHigh);
      
      // Interpolate date ranges:
      activeMonthRange = Math.round(baseActive + factor * (maxActive - baseActive));
      soldMonthRange   = Math.round(baseSold + factor * (maxSold - baseSold));
    }
    
    // Build the price range query using the determined multipliers.
    let priceFloorQuery = expectedCurrentPrice
      ? `[${Math.round(expectedCurrentPrice * multiplierLow)} TO ${Math.round(expectedCurrentPrice * multiplierHigh)}]`
      : `[${latestPrice && latestPrice.value > 0 ? latestPrice.value : "100000"} TO *]`;
      
    if(userSuggestedPrice){
      priceFloorQuery = `[${Math.round(userSuggestedPrice * .75)} TO ${Math.round(userSuggestedPrice * 1.25)}]`
    }
    
    // Construct the full queries for active and sold properties.
    const activeDateQuery = `current_status:(active) AND last_listed_sale_price_all:${priceFloorQuery} AND ${getLastMonthsQuery("last_listed_sale_date_all", activeMonthRange)}`;
    const soldDateQuery = `current_status:(sold) AND last_sold_price:${priceFloorQuery} AND ${getLastMonthsQuery("last_sold_date", soldMonthRange)}`;



    //priceTrends = priceTrends.filter(item => item.count > 2)
    
    const compMatchQuery = `${bathsQuery}${sqFtQuery}${floorQuery}${buildingYearQuery}${buildingUnitQuery}${neighborhoodQuery}${buildingKeyQuery}${amenitiesQ}${userSuggestedPrice?bedroomQuery:null}`;

    let compQuery = {
        "q": compMatchQuery,
        "fq": [
            removeSubject,
            boroughQuery,
            "deleted:false",
            "sq_ft:[300 TO *]",
            "{!geofilt}",
            `${isHouse ? "" : "-address_2_normalized:\"\""}`,
            `${!userSuggestedPrice ? bedroomQuery : ""}`,
            ownershipTypeQuery
        ],
        "fl": [
            "full_street_address",
            "display_full_street_address",
            "zip",
            "address_2",
            "address_2_normalized",
            "floor",
            "bedrooms",
            "baths",
            "half_baths",
            "sq_ft",
            "exterior_sq_ft",
            "offering_price",
            "building",
            "building_name",
            "neighborhood",
            "borough",
            "monthly_fees",
            "monthly_taxes",
            "key",
            "total_units",
            "residential_units",
            "last_sold_price",
            "last_sold_date",
            "price",
            "last_listed_sale_price_all",
            "last_listed_sale_date_all",
            "last_listed_sale_modified_date_all",
            "last_listed_sale_ppsf_all",
            "last_listed_rent_price_all",
            "last_listed_rent_date_all",
            "last_contract_date",
            "last_contract_price",
            "last_contract_date_formatted",
            "last_listed_sale_key_all",
            "last_listed_rent_key_all",
            "last_listed_sale_status_all",
            "last_listed_rent_status_all",
            "id",
            "div(last_sold_price, sq_ft)",
            "div(last_listed_sale_price_all, sq_ft)",
            "div(last_contract_price, sq_ft)",
            "div(sub(offering_price, last_listed_sale_price_all), offering_price)",
            "div(sub(offering_price, last_sold_price), offering_price)",
            "owner",
            "ownership_type",
            "borough_code",
            "block",
            "lot",
            "year*",
            "building_class",
            "property_features",
            "building_features",
            "score"
        ],
        "wt": "json",
        "sfield": "geocode",
        "pt": building.geocode,
        "d": 2,
        "sort": "score desc, geodist() asc",
        "start": 0,
        "rows": 8,
        "group": true,
        "group.limit":3,
        "group.query": [
            activeDateQuery,
            soldDateQuery
        ]
    };
    setFetchInProgress(true);
    let axiosData = {
      url: apiURL + "/query/we3-properties?cache=60",
      method: "post",
      query: compQuery,
    };

    let res = await _axiosCall(axiosData);
    
    const activeComps = res[activeDateQuery] && res[activeDateQuery].doclist && res[activeDateQuery].doclist.docs ? res[activeDateQuery].doclist.docs : [];
    const soldComps = res[soldDateQuery] && res[soldDateQuery].doclist && res[soldDateQuery].doclist.docs ? res[soldDateQuery].doclist.docs : [];
    let activePPSF = activeComps.map(item => item["div(last_listed_sale_price_all, sq_ft)"]);
    let soldPPSF = soldComps.map(item => item["div(last_sold_price, sq_ft)"]);
    const sum = [...activePPSF, ...soldPPSF].reduce((total, value) => total + value, 0); // Sum all elements
    const avgPPSF = sum / [...activePPSF, ...soldPPSF].length;

    let suggestedPrice = userSuggestedPrice ? userSuggestedPrice : expectedCurrentPrice ? expectedCurrentPrice : Math.round(avgPPSF * property.sq_ft);
    
    console.log("suggestedPrice", _formatCurrency(suggestedPrice))
    
    res[activeDateQuery].doclist.docs.map(item => {
      console.log(priceTrends, property, item);
      const result = calculateRelativeValue(priceTrends, property, item);
      console.log(result);
    })
    
    const avgDOM = currentDOM && currentDOM.avg_dom ? currentDOM.avg_dom : null;
    const avgDiscount = currentDiscount && currentDiscount.avg_discount ? currentDiscount.avg_discount : null;
    
    return({expectedCurrentPrice : roundUpToNearest(expectedCurrentPrice), suggestedPrice: roundUpToNearest(suggestedPrice), latestPrice, priceChange, comps:{active:activeComps, sold:soldComps, priceTrends: priceTrends },domTrends: domTrends, avgDOM : avgDOM, discountTrends: discountTrends, avgDiscount : avgDiscount, ppsfTrends: ppsfTrends, currentCashBuyers, currentFinancedBuyers, activityResponse})

  }

  const getPriceTrends = async (building, latestPrice) => {
    console.log(building,latestPrice);
    if(!building || !building.neighborhood) return null;
    
   

    let defaultQ = `ownership_type:"${building.ownership_type.split('-')[0]}"`
    let isHouse = _isHouse(building);
    if(isHouse){
      defaultQ = `ownership_type:*family*`
    }
    const fq = [
      "status:sold",
      "transaction_source:ACRIS*",
      "price:[50000 TO *]",
      "parcels_count:1",
      `{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`,
    ];

    let axiosData = {
      url: apiURL + "/query/we3-transactions?cache=60",
      method: "post",
      query: {
        q: `(((neighborhood:"${building.neighborhood[0].toLowerCase()}" OR markets_major:"${
          building.markets_major[0]
        }") AND borough:"${building.borough.toLowerCase()}"))`,
        fq: fq,
        fl: null,
        rows: 0,
        start: 0,
        wt: "json",
        "json.facet": {
          price_trend: {
            type: "query",
            q: "price_per_sqft:[300 TO 20000]",
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: latestPrice.date,
                  end: "NOW",
                  gap: "+6MONTHS",
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                    med_ppsf: "percentile(price_per_sqft, 50)",
                    avg_price: "avg(price)"
                  },
                },
              },
            },
          },
          current_dom: {
            type: "query",
            q: "days_to_contract:[10 TO 600] AND close_date_formatted:[NOW-6MONTHS TO NOW]",
            facet: {
                    avg_dom : "avg(days_to_contract)"
            },
          },
          dom_trend: {
            type: "query",
            q: "days_to_contract:[10 TO 600]",
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: "2015-01-01T05:00:00Z",
                  end: "NOW",
                  gap: "+1YEAR",
                  facet: {
                    avg_dom : "avg(days_to_contract)"
                  },
                },
              },
            },
          },
          current_discount: {
            type: "query",
            q: "discount:[-30 TO 30] AND close_date_formatted:[NOW-6MONTHS TO NOW]",
            facet: {
                    avg_discount : "avg(discount)"
            },
          },
          discount_trend: {
            type: "query",
            q: "discount:[-30 TO 30]",
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: "2015-01-01T05:00:00Z",
                  end: "NOW",
                  gap: "+1YEAR",
                  facet: {
                    avg_discount : "avg(discount)"
                  },
                },
              },
            },
          },
          ppsf_trend: {
            type: "query",
            q: "price_per_sqft:[300 TO 20000]",
            facet: {
              by_time: {
                range: {
                  field: "close_date_formatted",
                  start: "2015-01-01T05:00:00Z",
                  end: "NOW",
                  gap: "+1YEAR",
                  facet: {
                    avg_ppsf: "avg(price_per_sqft)",
                    med_ppsf: "percentile(price_per_sqft, 50)",
                  },
                },
              },
            },
          },
          current_cash_buyers: {
              type: "query",
              q: "-lender:* AND close_date_formatted:[NOW-6MONTHS TO NOW]"
          },
          current_financed_buyers: {
              type: "query",
              q: "lender:* AND close_date_formatted:[NOW-6MONTHS TO NOW]",
              facet:{
                avg_financed: "avg(percent_financed)"
              }
          }
        },
      },
    };
    let res = await _axiosCall(axiosData);
    if(res && res.facets && res.facets.price_trend && res.facets.price_trend.by_time && res.facets.price_trend.by_time.buckets){
      return {price_trend : res.facets.price_trend.by_time.buckets, dom_trend:res.facets.dom_trend.by_time.buckets, current_dom: res.facets.current_dom, discount_trend:res.facets.discount_trend.by_time.buckets, current_discount: res.facets.current_discount, ppsf_trend : res.facets.ppsf_trend.by_time.buckets, current_cash_buyers: res.facets.current_discount, current_financed_buyers: res.facets.current_financed_buyers } ;
    }
    return null;

  };
  
  const getActivities = async (building) => {
   if(!building || !building.neighborhood) return null;
   
   let defaultQ = `event_tags:*${building.ownership_type.split('-')[0]}* AND (neighborhood:"${building.neighborhood[0].toLowerCase()}" AND borough:"${building.borough.toLowerCase()}")`
   
    let isHouse = _isHouse(building);
    if(isHouse){
      defaultQ = `event_tags:*family* AND (neighborhood:"${building.neighborhood[0].toLowerCase()}" AND borough:"${building.borough.toLowerCase()}")`
    }
    setFetchInProgress(true);
    let axiosData = {
      url: apiURL + "/query/we3-activities-3",
      method: "post",
      query: {
          "q": defaultQ,
          "fq": [
              "hierarchy:[0 TO 2]",
              "price:[100000 TO 300000000]"
          ],
          "wt": "json",
          "rows": 0,
          "json.facet": {
              "by_time": {
                  "range": {
                      "field": "time",
                      start: "2020-01-01T05:00:00Z",
                      end: "NOW",
                      gap: "+1YEAR",
                      facet:{
                        "contract_signed": {
                            "type": "query",
                            "q": "topic:listings AND event_tags:contract-signed AND -event_tags:rent AND -event_tags:*commercial*"
                        },
                        "new_listings": {
                            "type": "query",
                            "q": "topic:listings AND event_tags:just-listed AND -event_tags:rent AND -event_tags:*commercial*"
                        }
                      }
                  }
              }
              
              
          }
      },
    };
  
    let res = await _axiosCall(axiosData);
    if(res && res.facets.by_time.buckets){
        return res.facets.by_time.buckets
    }else{
      return null;
    }
  };

  if (!reportData) return null;

  //const buildingRes = reportData.buildingRes.building[0];

  {
    console.log(reportData, "reportData");
  }
  // 
  // let subjectProperty = reportData.compSettings.propertyDetails.property;
  // subjectProperty['suggestedPrice'] = reportData && reportData.compResponse && reportData.compResponse.suggestedPrice ? reportData.compResponse.suggestedPrice : 0;
  // subjectProperty['suggestedPricePPSF'] = subjectProperty['suggestedPrice'] / subjectProperty['sq_ft'];
  // subjectProperty['suggestedPriceLow'] = subjectProperty['suggestedPrice']  * .9;
  // subjectProperty['suggestedPriceHigh'] = subjectProperty['suggestedPrice']  * 1.1;
  // let avgDOM = reportData.compResponse.avgDOM ? reportData.compResponse.avgDOM : null;
  // let avgDiscount = reportData.compResponse.avgDiscount ? (Number.parseFloat(reportData.compResponse.avgDiscount).toFixed(1) * -1) : null;
  // let activeComps = reportData.compResponse.comps.active.slice(0, 3);
  // let avgActiveComps = calculateAverages(activeComps, "last_listed_sale_price_all", "sq_ft");
  // let soldComps = reportData.compResponse.comps.sold.slice(0, 3);
  // let avgSoldComps = calculateAverages(soldComps, "last_sold_price", "sq_ft");
  // let currentCashBuyers = reportData.compResponse.currentCashBuyers;
  // let currentFinancedBuyers = reportData.compResponse.currentFinancedBuyers;
  // let percentCashBuyers = currentCashBuyers.count && currentFinancedBuyers.count ? Number.parseFloat((currentCashBuyers.count / (currentCashBuyers.count + currentFinancedBuyers.count))* 100).toFixed(0) : '--';
  // let percentFinanced = currentFinancedBuyers.avg_financed ?  Number.parseFloat((100-currentFinancedBuyers.avg_financed)).toFixed(0) : '--';
  // let activityResponse = reportData.compResponse.activityResponse ? reportData.compResponse.activityResponse : null;
  
  const {
    subjectProperty,
    avgDOM,
    avgDiscount,
    activeComps,
    avgActiveComps,
    soldComps,
    avgSoldComps,
    currentCashBuyers,
    currentFinancedBuyers,
    percentCashBuyers,
    percentFinanced,
    activityResponse,
    isCoop
  } = reportData.derivedData;
  

  
  return (
    <>
      <div className="report-container page-section comp-view building-view-3-page-1">
        <SubHeader reportData={reportData} />
        <div className="vertical-divider"></div>
        <div className="horizontal-divider"></div>
        <div className="border-divider"></div>
        <section className="report-section">
          <div class="suggested-price-card">
            <Icon />
            <div class="price-details">
              <p class="label editable">Suggested List Price</p>
              <h2 class="price editable">
                {subjectProperty['suggestedPrice']
                  ? _formatCurrency(subjectProperty['suggestedPrice'])
                  : "--"}
              </h2>
            </div>
            <div class="divider"></div>
            <div class="range-details">
              <p class="label editable">Range</p>
              <h3 class="range editable">
                {subjectProperty['suggestedPriceLow']
                  ? `${_formatPrice(
                      roundUpToNearest(
                        subjectProperty['suggestedPriceLow']
                      )
                    )}- ${_formatPrice(
                      roundUpToNearest(
                        subjectProperty['suggestedPriceHigh']
                      )
                    )}`
                  : "--"}
              </h3>
            </div>
          </div>
          <div className="center-container">
            <div className="left-side">
              <h3 className="sub-main-heading">How is the price determined?</h3>
              <p className="editable">
                {AiResponse && AiResponse.price_overview ? AiResponse.price_overview : <CustomSkeleton count={8}/>}
                
              </p>
              <p className="editable">
                {AiResponse && AiResponse.comp_overview ? AiResponse.comp_overview : <CustomSkeleton count={8}/>}
                
              </p>
              {/* <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Curabitur posuere aliquet odio vitae vulputate. Proin eget leo
                nunc. Vivamus consequat commodo leo id varius. Orci varius
                natoque penatibus et magnis dis parturient montes, nascetur
                ridiculus mus. Vivamus vitae lectus at nisi semper varius a a
                mi. Mauris et scelerisque odio.{" "}
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Curabitur posuere aliquet odio vitae vulputate. Proin eget leo
                nunc. Vivamus consequat commodo leo id varius. Orci varius
                natoque penatibus et magnis dis parturient montes, nascetur
                ridiculus mus. Vivamus vitae lectus at nisi semper varius a a
                mi. Mauris et scelerisque odio.
              </p> */}
            </div>
            <div className="right-side">
              <div className="column1">
                <div className="main-title">
                  <span>{_formatNumber(avgDOM)}</span>
                  <span>Days</span>
                </div>
                <h3 className="editable">typical Days on market</h3>
                <p className="editable">
                 {AiResponse && AiResponse.days_on_market ? AiResponse.days_on_market : <CustomSkeleton count={11}/>}
                </p>
              </div>
              <div className="column2">
                <div className="main-title">
                  <span>{avgDiscount}%</span>
                </div>
                <h3 className="editable">typical Discount</h3>
                <p className="editable">
                 {AiResponse && AiResponse.discount ? AiResponse.discount : <CustomSkeleton count={11}/>}
                </p>
              </div>
            </div>
          </div>
          <div className="last-cont">
            <div className="circle_container">
              <h3 className="sub-main-heading">Buyers of similar properties</h3>
              <div className="circle_inner_main_wraper">
                <div className="semi-progress-container">
                  <CircularProgress value={percentCashBuyers} />
                  <span className="editable">CASH BUYERS</span>
                </div>
                {!isCoop ? <div className="semi-progress-container">
                  <CircularProgress value={percentFinanced} />
                  <span className="editable">DOWN PAYMENT</span>
                </div>:null}
              </div>
              <p className="editable">
               {AiResponse && AiResponse.cash_finance ? AiResponse.cash_finance : <CustomSkeleton count={6}/>}
              </p>
            </div>
            <div className="right_side_circle-container">
              <h3>Pricing strategy</h3>
              <p className="editable">
               {AiResponse && AiResponse.pricing_strategy ? AiResponse.pricing_strategy : <CustomSkeleton count={12}/>}
              </p>
            </div>
          </div>
        </section>
      </div>
      <div className="report-container page-section building-view-3-page-1">
        <SubHeader reportData={reportData} />
        <div className="vertical-divider"></div>
        <div className="horizontal-divider"></div>
        <div className="border-divider"></div>
        <section className="report-section">
          <h3 className="editable">Comparable properties on the market</h3>
          <div className="property-type-values">
            <p className="editable">
              {AiResponse && AiResponse.active_comps ? AiResponse.active_comps : <CustomSkeleton count={8}/>}
            </p>
            <div className="property-type-numeric-content">
              <div>
                <div className="property-type-price editable">{avgActiveComps && avgActiveComps.avgPrice ? _formatPrice(avgActiveComps.avgPrice) : '--'}</div>
                <div className="property-asking-price editable">
                  Average Asking Price
                </div>
              </div>
              <div>
                <div className="property-type-price editable">{avgActiveComps && avgActiveComps.avgPPSF ? '$'+_formatNumber(avgActiveComps.avgPPSF) : '--'}</div>
                <div className="property-asking-price editable">Average Asking PSF</div>
              </div>
            </div>
          </div>
          <div className="property-comparison-container">
            {[...[formatPropertyData(subjectProperty, true)], ...activeComps.map(item => formatPropertyData(item))].map((property, index) => (
              <div
                key={property.id}
                className="property-card"
              >
                <div className="relative">
                  <img
                    src={property.img}
                    alt={property.title}
                    className="property-image"
                  />
                  <div
               className={`property-badge ${
                index===0 ? "badge-subject" : "badge-comp"
              }`}
            >
              {property.tag}
            </div>
                </div>

                <div className="property-details">
                  <div
                    className={`property-title-wrapper property-title-wrapper-${index}`}
                  >
                    <h3 className="property-title editable">{property.title}</h3>
                    <p className="property-location editable">{property.location}</p>
                  </div>
                  <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title editable">{property.type}</p>
                    <p className="property-info-subtext editable">
                      Year Built: {property.yearBuilt}
                    </p>
                  </div>

                  <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title editable">{property.bedsBaths}</p>
                    <p className="property-info-subtext editable">{property.size}</p>
                  </div>

                  <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title editable">{property.price}</p>
                    <p className="property-info-subtext editable">
                      {property.priceType}
                      {property.date ? ` (${property.date})` : null}
                    </p>
                    
                  </div>

                  <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title editable">{property.psf}</p>
                    <p className="property-info-subtext editable">{property.psfType}</p>
                  </div>

                  <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title editable">
                      {property.isSubject ? _formatNumber(avgDOM) : property.daysOnMarket}
                    </p>
                    <p className="property-info-subtext editable">{property.daysOnMarketHeading}</p>
                  </div>
                </div>
              </div>
            ))}
            {activeComps.length<=0 ? 
              <div className={`prpoerty-no-comps`}>
                <h3 className="editable">No Comps Available</h3>
                <p  className="editable">Due to the unique nature of the subject property, there are currently no suitable comparable properties on the market.</p>
              </div>
              :null
            }
          </div>
        </section>
      </div>
      <div className="report-container page-section building-view-3-page-1">
      <div className="vertical-divider"></div>
      <div className="horizontal-divider"></div>
      <div className="border-divider"></div>
   <SubHeader reportData={reportData} />
        <section className="report-section">
          <h3 className="editable">Recently sold comparable properties</h3>
          <div className="property-type-values">
            <p className="editable">
              {AiResponse && AiResponse.sold_comps ? AiResponse.sold_comps : <CustomSkeleton count={8}/>}
            </p>
            <div className="property-type-numeric-content">
              <div>
                <div className="property-type-price editable">{avgSoldComps && avgSoldComps.avgPrice ? _formatPrice(avgSoldComps.avgPrice) : '--'}</div>
                <div className="property-asking-price editable">
                  Average Sold Price
                </div>
              </div>
              <div>
                <div className="property-type-price editable">{avgSoldComps && avgSoldComps.avgPPSF ? '$'+_formatNumber(avgSoldComps.avgPPSF) : '--'}</div>
                <div className="property-asking-price editable">Average Sold PSF</div>
              </div>
            </div>
          </div>
          <div className="property-comparison-container">
           {[...[formatPropertyDataSold(subjectProperty, true)], ...soldComps.map(item => formatPropertyDataSold(item))].map((property, index) => (
              <div
                key={property.id}
                className={`property-card`}
              >
                <div className="relative">
                  <img
                    src={property.img}
                    alt={property.title}
                    className="property-image"
                  />
                  <div
              className={`property-badge ${
                index===0 ? "badge-subject" : "badge-comp"
              }`}
            >
              {property.tag}
            </div>
                </div>

                <div className="property-details">
                  <div
                    className={`property-title-wrapper property-title-wrapper-${index}`}
                  >
                    <h3 className="property-title editable">{property.title}</h3>
                    <p className="property-location editable">{property.location}</p>
                  </div>
                  <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title editable">{property.type}</p>
                    <p className="property-info-subtext editable">
                      Year Built: {property.yearBuilt}
                    </p>
                  </div>

                  <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title editable">{property.bedsBaths}</p>
                    <p className="property-info-subtext editable">{property.size}</p>
                  </div>

                  <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title editable">{property.price}</p>
                    <p className="property-info-subtext editable">
                      {property.priceType}
                      {property.date ? ` (${property.date})` : null}
                    </p>
                  </div>

                  <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title editable">{property.psf}</p>
                    <p className="property-info-subtext editable">{property.psfType}</p>
                  </div>

                  {/* <div
                    className={`property-info-box property-info-box-${index}`}
                  >
                    <p className="property-info-title">
                      {property.discount}
                    </p>
                    <p className="property-info-subtext">{property.discountHeading}</p>
                  </div> */}
                </div>
              </div>
            ))}
            {soldComps.length<=0 ? 
              <div className={`prpoerty-no-comps`}>
                <h3 className="editable">No Comps Available</h3>
                <p  className="editable">Due to the unique nature of the subject property, there are no recent comparable sales available.</p>
              </div>
              :null
            }
          </div>
        </section>
      </div>
      <div className="report-container page-section building-view-3-page-1 building-view-3-last-page">
      <SubHeader reportData={reportData} subtext="NEIGHBORHOOD ANALYSIS"/>
      <div className="vertical-divider"></div>
      <div className="horizontal-divider"></div>
      <div className="border-divider"></div>
        <section className="report-section">
          <div className="">
            <h3 className="editable">Supply & demand</h3>
            <div className="content_wrapper">
              <div className="content">
              <p className="editable">
                {AiResponse && AiResponse.supply_demand_1 ? AiResponse.supply_demand_1 : <CustomSkeleton count={6}/>}
              </p>
              <p className="editable">
                {AiResponse && AiResponse.supply_demand_2 ? AiResponse.supply_demand_2 : <CustomSkeleton count={7}/>}
              </p>
              </div>
              <div className="bar-multichart">
                <MultipleBarCharts
                data={activityResponse.map(item => {
                  return { date: item.val.slice(0,4), value1: item.new_listings && item.new_listings.count ? Math.round(item.new_listings.count) : 0, value2:  item.contract_signed && item.contract_signed.count ? Math.round(item.contract_signed.count) : 0}})}
                  
                  height={300}
                  isWeekly={dateOptions.gap}
                  legendNames={{
                    value1: "Supply",
                    value2: "Demand"
                  }}
                />
              </div>
            </div>
            <h3 className="editable">Price Trends</h3>
            <div className="center-part">

              <div className="line-chart">
              <CustomLineChart
                    theme={theme}
                    data={reportData.compResponse.ppsfTrends.map(item => {
                    return { date: item.val.slice(0,4), value: Math.round(item.med_ppsf)}})}
                    
                    isWeekly={dateOptions.gap}
                    height={270}
                    formatter={(value)=>'$'+_formatNumber(value)}
                  />
              </div>
           <div className="content">
           <p className="editable">
             {AiResponse && AiResponse.price_trend ? AiResponse.price_trend : <CustomSkeleton count={12}/>}
           </p>
              
           </div>
            </div>
          </div>
          <div className="last-part">
            <div>
              <h3 className="editable">Days on Market</h3>
              <p className="editable">
                {AiResponse && AiResponse.dom_trend ? AiResponse.dom_trend : <CustomSkeleton count={8}/>}
              </p>
            <div>
            <MultipleBarCharts
                  data={reportData.compResponse.domTrends.map(item => {
                    return { date: item.val.slice(0,4), value1: Math.round(item.avg_dom) }})}
                  height={260}
                  isWeekly={dateOptions.gap}
                  secondValue={false}
                />
            </div>
            </div>
            <div>
              <h3 className="editable">Discount</h3>
              <p className="editable">
                {AiResponse && AiResponse.discount_trend ? AiResponse.discount_trend : <CustomSkeleton count={8}/>}
              </p>
              <CustomLineChart
                    theme={theme}
                    data={reportData.compResponse.discountTrends.map(item => {
                    return { date: item.val.slice(0,4), value:(Number.parseFloat(item.avg_discount).toFixed(1) * -1)}})}
                    isWeekly={dateOptions.gap}
                    height={260}
                    formatter={(value)=> value+'%'}
                  />
            </div>
          </div>
        </section> 
      </div>
    </>
  );
};

export default BlendedLayout;
